document.addEventListener('DOMContentLoaded', function() {

  // --- Quantity Selector Logic ---
  function updateAddToCartForQuantity() {
    var activeBundle = document.querySelector('.frequency-bundles-item.active');
    if (!activeBundle) return;
    var frcType = activeBundle.getAttribute('frc-type');
    var quantityInput = document.querySelector('.quantity-selector__input');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    if (isNaN(quantity) || quantity < 1) quantity = 1;
    var btn = document.querySelector('#AddToCart .loader-button__text') || document.getElementById('AddToCart');
    if (!btn) return;
    if (prdAvailable == 'true') {
      var btnText = (typeof btnTextaddtocart !== 'undefined' ? btnTextaddtocart : 'Add to cart');
    } else {
      var btnText = btnTextsold;
    }
 
    var result = '';
    if (frcType === 'otp') {
      var frcPrice = activeBundle.getAttribute('frc-price');
      if (frcPrice) {
        var total = (parseFloat(frcPrice) * quantity) / 100;
        if (curSymbol == '$') {
          total = curSymbol+total;
        } else {
          total = total+curSymbol;
        }
        result = btnText + '&nbsp;-&nbsp;' + total;
        btn.innerHTML = result;
      }
    } else if (frcType === 'subscr') {
      var fbisSelect = document.getElementById('fbis-select');
      if (fbisSelect) {
        var selectedOption = fbisSelect.options[fbisSelect.selectedIndex];
        if (selectedOption) {
          var pricePrc = selectedOption.getAttribute('pricePrc');
          if (pricePrc) {
            var total = (parseFloat(pricePrc) * quantity) / 100;
            if (curSymbol == '$') {
              total = curSymbol+total;
            } else {
              total = total+curSymbol;
            }
            result = btnText + '&nbsp;-&nbsp;' + total;
            btn.innerHTML = result;
          }
        }
      }
    }
  }

  var minusBtn = document.querySelector('.quantity-selector__button-minus');
  var plusBtn = document.querySelector('.quantity-selector__button-plus');
  var qtyInput = document.querySelector('.quantity-selector__input');
  if (minusBtn) minusBtn.addEventListener('click', function() { setTimeout(updateAddToCartForQuantity, 10); });
  if (plusBtn) plusBtn.addEventListener('click', function() { setTimeout(updateAddToCartForQuantity, 10); });
  if (qtyInput) qtyInput.addEventListener('input', function() { setTimeout(updateAddToCartForQuantity, 10); });
  // Also update when frequency or plan changes
  document.addEventListener('click', function(e) {
    if (e.target.closest('.frequency-bundles-item')) setTimeout(updateAddToCartForQuantity, 10);
    if (e.target.closest('.subscr-plan')) setTimeout(updateAddToCartForQuantity, 10);
  });
  var fbisSelect = document.getElementById('fbis-select');
  if (fbisSelect) fbisSelect.addEventListener('change', function() { setTimeout(updateAddToCartForQuantity, 10); });
  setTimeout(updateAddToCartForQuantity, 50);

 
  // Add click handler for frequency-bundles-item
  var bundles = document.querySelectorAll('.frequency-bundles-item');
  bundles.forEach(function(item) {
    item.addEventListener('click', function() {
      bundles.forEach(function(el) {
        el.classList.remove('active');
      });
      this.classList.add('active');
      var frcType = this.getAttribute('frc-type');
      var sellingPlanInput = document.getElementById('selling-plan-input');
      var addToCartButton = document.querySelector('#AddToCart');
      var buttonTextElement = document.querySelector('#AddToCart .loader-button__text') || addToCartButton;
      
      if (frcType === 'otp') {
        var frcPrice = this.getAttribute('frc-price');
        if (buttonTextElement && frcPrice) {
            let btnTextaddtocartCont = '';
            let dfrcPrice = frcPrice / 100;
            if (curSymbol == '$') {
              dfrcPrice = curSymbol+dfrcPrice;
            } else {
              dfrcPrice = dfrcPrice+curSymbol;
            }
            if (prdAvailable == 'true') {
              var btnText1 = (typeof btnTextaddtocart !== 'undefined' ? btnTextaddtocart : 'Add to cart');
            } else {
              var btnText1 = btnTextsold;
            }
            
            btnTextaddtocartCont =  btnText1 + '&nbsp;-&nbsp;' + dfrcPrice;
            buttonTextElement.innerHTML = btnTextaddtocartCont;
        }
        if (sellingPlanInput) {
          sellingPlanInput.value = '';
        }
      } else if (frcType === 'subscr') {
        var fbisSelect = document.getElementById('fbis-select');
        if (fbisSelect) {
          var selectedOption = fbisSelect.options[fbisSelect.selectedIndex];
          if (selectedOption) {
            if (sellingPlanInput) {
              sellingPlanInput.value = selectedOption.getAttribute('value');
            }
            var pricePrc = selectedOption.getAttribute('pricePrc');
            if (buttonTextElement && pricePrc) {
                let btnTextaddtocartCont = '';
                let dfrcPrice = pricePrc / 100;
                if (curSymbol == '$') {
                  dfrcPrice = curSymbol+dfrcPrice;
                } else {
                  dfrcPrice = dfrcPrice+curSymbol;
                }
                if (prdAvailable == 'true') {
                  var btnText2 = (typeof btnTextaddtocart !== 'undefined' ? btnTextaddtocart : 'Add to cart');
                } else {
                  var btnText2 = btnTextsold;
                }
   
                btnTextaddtocartCont =  btnText2 + '&nbsp;-&nbsp;' + dfrcPrice;
                buttonTextElement.innerHTML = btnTextaddtocartCont;
            }
          }
        }
      }
    });
  });
  var fbisSelect = document.getElementById('fbis-select');
  var sellingPlanInput = document.getElementById('selling-plan-input');
  var addToCartButton = document.querySelector('#AddToCart');
  var buttonTextElement = document.querySelector('#AddToCart .loader-button__text') || addToCartButton;
  

  if (fbisSelect) {
    fbisSelect.addEventListener('change', function() {
      var selectedOption = this.options[this.selectedIndex];
      if (!selectedOption) return;
      // 1. Set value to selling-plan-input
      if (sellingPlanInput) {
        sellingPlanInput.value = selectedOption.getAttribute('value');
      }
      // 2. Update AddToCart button text with pricePrc
      var pricePrc = selectedOption.getAttribute('pricePrc');
      if (pricePrc && buttonTextElement) {
        let btnTextaddtocartCont = '';
        let dfrcPrice = pricePrc / 100;
        if (curSymbol == '$') {
          dfrcPrice = curSymbol+dfrcPrice;
        } else {
          dfrcPrice = dfrcPrice+curSymbol;
        }
        if (prdAvailable == 'true') {
          var btnText3 = (typeof btnTextaddtocart !== 'undefined' ? btnTextaddtocart : 'Add to cart');
        } else {
          var btnText3 = btnTextsold;
        }
      
        btnTextaddtocartCont =  btnText3 + '&nbsp;-&nbsp;' + dfrcPrice;
        buttonTextElement.innerHTML = btnTextaddtocartCont;
      }
      // 3. Set cnt-sbd text to optnName attribute
      var cntSbdElem = document.getElementById('cnt-sbd');
      var optnName = selectedOption.getAttribute('optnName');
      if (cntSbdElem && optnName !== null) {
        cntSbdElem.textContent = optnName;
      }
    });
    // Trigger change on load for initial state
    fbisSelect.dispatchEvent(new Event('change'));
  }
});